// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Nunito_Sans_e83115', '__Nunito_Sans_Fallback_e83115'","fontWeight":700,"fontStyle":"normal"},"className":"__className_e83115"};